import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Select } from 'antd';
import { fetchSchools } from '@/apis/schools';
import { getRequestErrorMessage } from '@/utils/requestError';
import './index.scss';

const SchoolSelect = ({ value, onChange, schoolName, disabled, ...props }) => {
  const [query, setQuery] = useState(''); const [search, setSearch] = useState('');
  const [items, setItems] = useState([]); const [page, setPage] = useState(1); const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false); const [error, setError] = useState(''); const sequence = useRef(0);
  const pending = useRef(false);
  const names = useRef(new Map());
  useEffect(() => { const timer = setTimeout(() => { setSearch(query.trim()); setPage(1); }, 300); return () => clearTimeout(timer); }, [query]);
  const load = useCallback(async () => {
    const version = ++sequence.current; pending.current = true; setLoading(true); setError('');
    if (page === 1) { setItems([]); setPagination(null); }
    try {
      const result = await fetchSchools({ ...(search ? { q: search } : {}), page, pageSize: 50 });
      if (!Array.isArray(result.data) || !result.pagination) throw new Error('学校目录响应无效');
      if (version === sequence.current) {
        result.data.forEach(item => names.current.set(String(item.id), item.name));
        setItems(previous => page === 1 ? result.data : [...previous, ...result.data.filter(item => !previous.some(old => String(old.id) === String(item.id)))]);
        setPagination(result.pagination);
      }
    } catch (err) { if (version === sequence.current) setError(getRequestErrorMessage(err, '学校目录加载失败，请重试')); }
    finally { if (version === sequence.current) { pending.current = false; setLoading(false); } }
  }, [page, search]);
  useEffect(() => { load(); return () => { sequence.current += 1; }; }, [load]);
  const options = items.map(item => ({ value: String(item.id), label: item.name }));
  if (value != null && !options.some(item => item.value === String(value))) options.unshift({ value: String(value), label: schoolName || names.current.get(String(value)) || `已选学校（${value}）` });
  return <div className="schoolSelect">
    <Select {...props} value={value == null ? undefined : String(value)} onChange={onChange} disabled={disabled} showSearch={{ filterOption: false, onSearch: setQuery }} loading={loading} options={options} placeholder={props.placeholder || '搜索并选择学校'}
      notFoundContent={loading ? '正在加载学校…' : error || '暂无匹配学校'} onPopupScroll={event => {
        const node = event.target;
        if (!pending.current && !error && pagination?.page < pagination?.totalPages && node.scrollHeight - node.scrollTop - node.clientHeight < 40) { pending.current = true; setPage(current => current + 1); }
      }} />
    {error && <div className="schoolSelect-error" role="alert">{error}<Button type="link" size="small" onClick={load}>重试</Button></div>}
  </div>;
};
export default SchoolSelect;
